import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from '../../../../i18n'
import { StepWizardChildProps } from 'react-step-wizard'
import { isMobile } from 'react-device-detect'

import XFAQNav from '../../../components/XFAQNav'
import XBack from '../../../components/XBack'

import styles from './style.module.scss'
import XCard from '../../xCard'
import XText from '../../../components/XText'
import XColors from '../../../styles/colors'

interface Props {
    onBack: () => void
}

const HelpFAQ: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { t } = useTranslation(window.LANG_NS)
    const [activeCategory, setActiveCategory] = useState(window.location.hash.replace('#', '') || 'general')

    const faqCategories = useMemo(() => {
        return {
            general: 'general',
            directDeposit: 'direct_deposit',
            prepaidCards: 'prepaid_cards',
            paypalAndVenmo: 'paypal_and_venmo',
        }
    }, [])

    const activeIndex = useMemo(() => {
        return Object.keys(faqCategories).findIndex((i) => i === activeCategory)
    }, [activeCategory, faqCategories])

    useEffect(() => {
        const handleHashChange = () => {
            setActiveCategory(window.location.hash.replace('#', ''))
        }

        window.addEventListener('hashchange', handleHashChange)

        return () => {
            window.removeEventListener('hashchange', handleHashChange)
        }
    }, [])

    useEffect(() => {
        if (process.browser) {
            const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
            if (window.location.hash && isChrome) {
                setTimeout(() => {
                    const hash = window.location.hash
                    window.location.hash = ''
                    window.location.hash = hash
                }, 300)
            }
        }
    }, [t])

    return (
        <div id="helpFAQ" className={styles.helpFAQ}>
            {!isMobile && <XBack onClick={props.onBack} />}

            <XFAQNav categories={faqCategories} active={activeIndex} />
            <XCard
                title={t(faqCategories[activeCategory])}
                backButton={isMobile ? t('back') : null}
                backButtonAction={isMobile ? props.onBack : null}
            >
                {t('faq_list', {
                    returnObjects: true,
                    phone_number: window.ORGANIZATION_CONFIGS.phoneNumber,
                    support_email: window.ORGANIZATION_CONFIGS.replyToEmail,
                })
                    // @ts-ignore
                    .filter((section, key) => section.name === activeCategory)
                    .map((section, key) => {
                        return section.items.map((item) => {
                            return [
                                <XText color={XColors.secondaryTextColor} key={`${item.question}`}>
                                    <strong>
                                        <p>{item.question}</p>
                                    </strong>
                                    {item.answers.map((answer, index) => {
                                        return (
                                            <p
                                                key={`${item.question}-${index}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: answer.html.replace(/<\/?li>/g, ''),
                                                }}
                                            />
                                        )
                                    })}
                                </XText>,
                            ]
                        })
                    })}
            </XCard>
        </div>
    )
}

export default HelpFAQ
